export default "__VITE_ASSET__C0QT3Bk7__"